module.exports = __webpack_public_path__ + "img/Weapon_31.4e8ad562.png";